import { getDefaultExportFromCjs } from './_commonjsHelpers.js';
import { __require as requireMoment } from './../ext/moment/moment.js';

var momentExports = requireMoment();
var moment = /*@__PURE__*/getDefaultExportFromCjs(momentExports);

export { moment as default };
//# sourceMappingURL=moment.js.map
